import * as ROUTES from "../../routes";

import TalifLogo from "../../image/footer/talif-logo.png";
import ParkModaresLogo from "../../image/footer/modaresPark.png";
import ZistKhalagLogo from "../../image/footer/zistkhalagh.png";
import IranLab from "../../image/footer/iranlab-logo.jpg";

export const footerLists = {
  "راهنمای مشتریان": [
    {
      id: 1,
      text: "سوالات متداول",
      path: ROUTES.ROUTE_FAQ,
    },
    {
      id: 2,
      text: "قوانین و مقررات",
      path: ROUTES.ROUTE_POLICIES,
    },
    {
      id: 3,
      text: "حریم خصوصی",
      path: ROUTES.ROUTE_PRIVACY,
    },
    {
      id: 4,
      text: "درباره ما",
      path: ROUTES.ROUTE_ABOUT_US,
    },
    {
      id: 5,
      text: "تماس با ما",
      path: ROUTES.ROUTE_CONTACT,
    },
  ],
  "دسترسی سریع": [
    {
      id: 1,
      text: "آزمایشگاه",
      path: ROUTES.ROUTE_SIMS, // phat for react-router-dom Link
    },
    {
      id: 2,
      text: "بلاگ",
      href: ROUTES.ROUTE_BLOG, // href for <a> tag
    },
    // TODO: #Future feature
    // {
    //   id: 3,
    //   text: "مسابقات",
    //   path: "/#", // TODO: Create tournaments route when it's UI is completed
    // },
    {
      id: 4,
      text: "اشتراک گروهی",
      path: "/group-purchase",
    },
  ],
};

export const certificateList = [
  {
    id: 1,
    href: "https://logo.samandehi.ir/Verify.aspx?id=210656&p=uiwkrfthobpdgvkadshwgvka",
    imgId: "nbqejxlzesgtfukzapfufukz",
    imgSrc:
      "https://logo.samandehi.ir/logo.aspx?id=210656&p=odrfnbpdlymawlbqujynwlbq",
    alt: "logo-samandehi",
  },
  {
    id: 2,
    href: "https://trustseal.enamad.ir/?id=205513&Code=n0SsK2lYxJ0yYvRsLwgY",
    target: "_blank",
    imgId: "n0SsK2lYxJ0yYvRsLwgY",
    imgSrc:
      "https://Trustseal.eNamad.ir/logo.aspx?id=205513&Code=n0SsK2lYxJ0yYvRsLwgY",
    alt: "azeto-enamad",
    referrerPolicy: "origin",
  },
  {
    id: 3,
    href: "https://standard.roshd.ir/software/13/%D8%A2%D8%B2%D8%AA%D9%88-%D8%B3%D8%A7%D9%85%D8%A7%D9%86%D9%87-%D8%B4%D8%A8%DB%8C%D9%87-%D8%B3%D8%A7%D8%B2-%D8%A2%D8%B2%D9%85%D8%A7%DB%8C%D8%B4%DA%AF%D8%A7%D9%87",
    target: "_blank",
    imgSrc: TalifLogo,
    alt: "roshd-certificate",
  },
  {
    id: 4,
    href: "https://mstpark.com/",
    target: "_blank",
    imgSrc: ParkModaresLogo,
    alt: "park-modarres",
  },
  {
    id: 5,
    href: "https://ircreative.isti.ir/web/creative_company",
    target: "_blank",
    imgSrc: ZistKhalagLogo,
    alt: "گواهی شرکت خلاق آزتو",
    referrerPolicy: "origin",
  },
  {
    id: 6,
    href: "https://iranlabexpo.ir/company/4611/%D9%85%D9%88%D8%B3%D8%B3%D9%87-%D9%81%D8%B1%D8%A2%D9%85%D9%88%D8%B2-%D9%87%D9%86%D8%AF%D8%A7%D8%B3%D9%87",
    target: "_blank",
    imgSrc: IranLab,
    alt: "گواهی ایران‌ساخت آزتو",
    referrerPolicy: "origin",
  },
];
